/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Indexnow_Key_File_OkInputs */

const en_admin_indexnow_key_file_ok = /** @type {(inputs: Admin_Indexnow_Key_File_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live, verification will pass`)
};

/**
* | output |
* | --- |
* | "Live, verification will pass" |
*
* @param {Admin_Indexnow_Key_File_OkInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_indexnow_key_file_ok = /** @type {((inputs?: Admin_Indexnow_Key_File_OkInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Indexnow_Key_File_OkInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_indexnow_key_file_ok(inputs)
});
export { admin_indexnow_key_file_ok as "admin.indexnow.key_file_ok" }